import { render, staticRenderFns } from "./VehiclesRegoSearchForm.vue?vue&type=template&id=5ff4931c&scoped=true&"
import script from "./VehiclesRegoSearchForm.vue?vue&type=script&lang=ts&"
export * from "./VehiclesRegoSearchForm.vue?vue&type=script&lang=ts&"
import style0 from "./VehiclesRegoSearchForm.vue?vue&type=style&index=0&id=5ff4931c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff4931c",
  null
  
)

export default component.exports